var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowerPot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_58232",
    "data-name": "Group 58232",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.835,
    height: 78.989,
    viewBox: "0 0 80.835 78.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42159",
    "data-name": "Path 42159",
    d: "M100.778,23.865c0,3.222-17.793,5.832-39.741,5.832S21.3,27.087,21.3,23.865,37.582,6.52,59.528,6.52,100.778,20.642,100.778,23.865Z",
    transform: "translate(-21.3 -6.52)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(0 10.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_5",
    "data-name": "<Group>",
    transform: "translate(5.524 16.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M121.493,169.1l-34.2.452L53.1,169.1l8.758,44.536c0,3.041,11.4,5.526,25.456,5.526s25.456-2.485,25.456-5.526a.753.753,0,0,0-.017-.087Z",
    transform: "translate(-52.42 -168.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    d: "M84.08,216.617c-12.911,0-25.978-2.1-26.134-6.134l-8.74-44.466a.623.623,0,0,1,.139-.573.739.739,0,0,1,.521-.243l34.214.452,34.179-.452a.708.708,0,0,1,.521.243.683.683,0,0,1,.156.573l-8.74,44.327a.154.154,0,0,1,.017.07C110.214,214.479,97.06,216.617,84.08,216.617Zm-33.4-50.044,8.6,43.7a.571.571,0,0,1,.017.139c0,2.016,9.418,4.848,24.779,4.848,15.343,0,24.779-2.832,24.779-4.848,0,.017-.017,0-.017-.035a.975.975,0,0,1,.017-.191l8.584-43.615-33.363.434Z",
    transform: "translate(-49.186 -165.2)",
    fill: "#5e2c00",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M302.687,169.1l-25.248.33a4.142,4.142,0,0,1,2.016,2.467c1.616,5.109.782,11.19.278,16.4-.556,5.8-.886,11.677-1.581,17.446-.573,4.813-2.415,9.9-5.752,13.345,12.216-.4,21.564-2.693,21.564-5.456a.754.754,0,0,0-.017-.087Z",
    transform: "translate(-228.09 -151.689)",
    fill: "#bd6736",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_6",
    "data-name": "<Group>",
    transform: "translate(0 6.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    d: "M100.71,108.6H21.3l3.875,10.895c.765,4.136,16.525,7.454,35.865,7.454,19.826,0,35.17-3.632,35.882-7.767.017-.07,3.788-10.582,3.788-10.582Z",
    transform: "translate(-20.622 -107.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": "<Compound Path>",
    d: "M57.814,124.4c-16.942,0-35.448-2.78-36.508-7.958L17.432,105.6a.684.684,0,0,1,.087-.608.648.648,0,0,1,.556-.3h79.41a.648.648,0,0,1,.556.3.641.641,0,0,1,.087.608c-.99,2.78-3.562,9.939-3.771,10.53-.921,4.726-16.612,8.271-36.542,8.271ZM19.03,106.055l3.562,9.991.035.1c.591,3.336,14.892,6.9,35.187,6.9a120.3,120.3,0,0,0,24.952-2.311c7.229-1.616,10.044-3.6,10.269-4.9.017-.07.017-.122,3.493-9.783Z",
    transform: "translate(-17.396 -104.7)",
    fill: "#5e2c00",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    d: "M27.1,108.6a24.625,24.625,0,0,0,7.889,4.692,60.5,60.5,0,0,0,15.83,3.892c6.1.678,12.181.869,18.315,1.164,2.832.139,6.62.3,7.646,3.562a20.184,20.184,0,0,1,.851,4.587c13.814-1.095,23.528-4.049,24.084-7.315.017-.069,3.788-10.582,3.788-10.582Z",
    transform: "translate(-25.414 -101.702)",
    fill: "#bd6736",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_7",
    "data-name": "<Group>",
    transform: "translate(0.001)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    d: "M100.779,78.621c0,3.232-17.793,5.838-39.74,5.838S21.3,81.853,21.3,78.621c0-3.215,17.793-5.821,39.74-5.821S100.779,75.406,100.779,78.621Z",
    transform: "translate(-20.622 -72.122)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_6",
    "data-name": "<Path>",
    d: "M95.846,100.769c-10.773.3-22.676.4-32.946,4.292,7.194,1.512,19.062,2.485,32.511,2.485,12.163,0,23.041-.8,30.322-2.068A88.571,88.571,0,0,0,95.846,100.769Z",
    transform: "translate(-54.994 -95.208)",
    fill: "#bd6736",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_3",
    "data-name": "<Compound Path>",
    d: "M57.817,81.915a203.7,203.7,0,0,1-28.2-1.72C17.4,78.4,17.4,76.146,17.4,75.4c0-.73,0-2.989,12.216-4.8a206.735,206.735,0,0,1,28.2-1.7,206.735,206.735,0,0,1,28.2,1.7c12.216,1.807,12.216,4.066,12.216,4.8,0,.747,0,3.006-12.216,4.8a203.7,203.7,0,0,1-28.2,1.72Zm0-11.66c-26.012,0-39.062,3.3-39.062,5.143,0,1.859,13.05,5.161,39.062,5.161s39.062-3.3,39.062-5.161c0-1.842-13.05-5.143-39.062-5.143Z",
    transform: "translate(-17.4 -68.9)",
    fill: "#5f2d25",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_7",
    "data-name": "<Path>",
    d: "M86.189,220.625s-2.589-2.259-2.589,1.807,1.911,10.7,4.275,22.1c2.363,11.382,4.4,11.486,7.437,8.445C98.37,249.939,92.271,226.046,86.189,220.625Z",
    transform: "translate(-72.096 -193.743)",
    fill: "#fff799",
    opacity: 0.7,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Clip_Group_",
    "data-name": "<Clip Group>",
    transform: "translate(0.678 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_8",
    "data-name": "<Group>",
    transform: "translate(3.704 1.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_9",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_10",
    "data-name": "<Group>"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    d: "M96.376,28.334A10.655,10.655,0,0,0,92.71,24.39a9.521,9.521,0,0,0-4.935-1.46c-1.616-3.11-5.039-4.9-9.105-5.7a12.893,12.893,0,0,0-11.382,2.659,19.105,19.105,0,0,0-6.412,1.738c-3.771,1.894-7.333,5.491-8.115,9.8a17.744,17.744,0,0,0-2.693,1.025c-2.276,1.095-5.908,2.815-6.985,5.352-2.589,6.082,6.2,7.124,11.625,6.742a18.877,18.877,0,0,0,5.23,1.79A34.935,34.935,0,0,0,75,45.989a43.894,43.894,0,0,0,9.8.434c1.234-.07,2.485-.156,3.753-.278,5.4,1.79,12.2.591,17.5-.521,2.989-.626,7.889-1.842,7.871-5.856C113.874,31.114,104.213,27.048,96.376,28.334Z",
    transform: "translate(-42.617 -16.901)",
    fill: "#5f2d25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_9",
    "data-name": "<Path>",
    d: "M97.956,52.358c.782-.139,1.564-.348,2.328-.539-.869.035-1.738.035-2.606.017-.834.1-1.668.191-2.5.243h-.73q-1.529.174-3.076.243a39.728,39.728,0,0,1-4.553.122,67.709,67.709,0,0,1-10.461-.3c.209.07.4.156.608.209a41.337,41.337,0,0,1-8.323.417,25.448,25.448,0,0,1-3.493-.487A15.572,15.572,0,0,1,60.2,51.072a21.965,21.965,0,0,1-4.136-2.363,5.246,5.246,0,0,0,1.425,1.79c-5.717-.469-13.623-2.346-7.507-7.541a19.137,19.137,0,0,1,6.812-3.649l.8-.348a9.96,9.96,0,0,1,.712-1.72c.122-.417.226-.73.261-.834A12.7,12.7,0,0,1,64.28,30.03a15.182,15.182,0,0,1,4.744-1.7,20.45,20.45,0,0,1,7.037-.678,6.426,6.426,0,0,0-3.2-.851c3.545-1.911,7.593-1.859,11.885-.573a9.1,9.1,0,0,1,5.2,3.788,6.071,6.071,0,0,0-1.164.365,13.32,13.32,0,0,1,2.693.1,12.005,12.005,0,0,1,1.633.278,9.22,9.22,0,0,1,1.234.3,5.125,5.125,0,0,1,1.251.573,7.045,7.045,0,0,1,2.693,1.79,13.614,13.614,0,0,1,2.9,4.257,7.815,7.815,0,0,0-.261-1.616.843.843,0,0,1-.052-.122c6.082-.556,12.563,2.52,15.343,8.08,3.632,7.263-9.818,8.5-18.263,8.341Z",
    transform: "translate(-46.872 -23.844)",
    fill: "#8e4a40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_10",
    "data-name": "<Path>",
    d: "M58.279,40.855c1.512-5.23,6.151-10.374,11.364-11.434a16.791,16.791,0,0,1,9.418.8,5.19,5.19,0,0,0-1.39-1.581c-.365-.278-.417-1.043.174-1.112a14.743,14.743,0,0,1,9.748,2.207.611.611,0,0,1-.33,1.129,3.829,3.829,0,0,0-1.755.539c3.684-.5,7.906.191,10.582,2.1a10.864,10.864,0,0,1,4.327,7.02,7.709,7.709,0,0,1,1.06-2.1,1.665,1.665,0,0,1,1.129-.851c2.5-.278,5.977.817,8.184,1.981a13.878,13.878,0,0,1,6.03,6.308,5.2,5.2,0,0,0-.573-1.842c-2.78-5.56-9.262-8.636-15.343-8.08a.847.847,0,0,0,.052.122,7.814,7.814,0,0,1,.261,1.616,13.614,13.614,0,0,0-2.9-4.257,7.045,7.045,0,0,0-2.693-1.79,5.125,5.125,0,0,0-1.251-.573,9.22,9.22,0,0,0-1.234-.3,12,12,0,0,0-1.633-.278,13.32,13.32,0,0,0-2.693-.1,6.071,6.071,0,0,1,1.164-.365,9.1,9.1,0,0,0-5.2-3.788c-4.292-1.286-8.341-1.338-11.885.573a6.426,6.426,0,0,1,3.2.851,20.45,20.45,0,0,0-7.037.678,15.181,15.181,0,0,0-4.744,1.7,12.7,12.7,0,0,0-5.717,6.377c-.035.1-.139.417-.261.834a9.961,9.961,0,0,0-.712,1.72l-.8.348a19.137,19.137,0,0,0-6.812,3.649c-2.085,1.772-2.537,3.162-2,4.24A14.566,14.566,0,0,1,49.9,44.938a14.375,14.375,0,0,1,8.375-4.083Z",
    transform: "translate(-46.901 -23.844)",
    fill: "#b55f54"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_11",
    "data-name": "<Path>",
    d: "M170.153,132.6a1.7,1.7,0,0,0-1.981.122c-.782.539-1.877,2.016-1.477,3.076.035.66.434,1.147,1.373,1.025a3.363,3.363,0,0,0,2.554-2.728A1.783,1.783,0,0,0,170.153,132.6Z",
    transform: "translate(-145.065 -112.274)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_12",
    "data-name": "<Path>",
    d: "M245.146,133.9c.07-.1.122-.261-.052-.226a1.047,1.047,0,0,0-.9,1.043c0,.243.226.33.434.278a.956.956,0,0,0,.712-.73C245.407,134.024,245.3,133.92,245.146,133.9Z",
    transform: "translate(-209.163 -113.381)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_13",
    "data-name": "<Path>",
    d: "M327.274,135.561a4.271,4.271,0,0,0-4.448,2.52c-.017.069-.017.1-.035.174a1.3,1.3,0,0,0,.521,2.12c1.268.591,3.284-.191,4.327-.973a3.058,3.058,0,0,0,1.39-2.276C329.029,136.169,328.074,135.682,327.274,135.561Z",
    transform: "translate(-273.828 -114.9)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_14",
    "data-name": "<Path>",
    d: "M411.018,138.36a1.491,1.491,0,0,0-.4.226c-.452.365-.9,1.3-.1,1.581a1.863,1.863,0,0,0,2.172-1.512C412.651,137.682,411.626,137.908,411.018,138.36Z",
    transform: "translate(-346.224 -116.935)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_11",
    "data-name": "<Group>",
    transform: "translate(14.75 14.328)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_15",
    "data-name": "<Path>",
    d: "M157.911,102.908a10.807,10.807,0,0,0-10.078,1.112l-.1-.261c-2.189-10.669-23.3.66-19.844,6.533,3.058,5.161,13.31,3.249,17.967,1.911a3.81,3.81,0,0,0,1.39-.747c.834.956,2.381.817,3.58.956a26.311,26.311,0,0,0,6.29-.209c1.651-.209,5.56-.487,5.925-2.78C163.558,106.122,160.691,103.915,157.911,102.908Z",
    transform: "translate(-127.503 -99.355)",
    fill: "#5f2d25"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_16",
    "data-name": "<Path>",
    d: "M145.994,116.222a24.527,24.527,0,0,1-11.173-.608c-7.35-2.433,4.014-9.9,6.846-10.964,3.666-1.39,7.315-.313,9.036,2.711a9.389,9.389,0,0,1,1.025,3.666C152.11,115.04,149.087,115.735,145.994,116.222Z",
    transform: "translate(-131.537 -103.234)",
    fill: "#8e4a40"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_17",
    "data-name": "<Path>",
    d: "M132.91,114.009a10.879,10.879,0,0,1,4.639-5.821c3.7-2.363,9.852-4.709,13.154-.9-1.738-2.954-5.335-4-8.984-2.624-2.415.9-11.138,6.551-8.879,9.661Z",
    transform: "translate(-131.607 -103.245)",
    fill: "#b55f54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_18",
    "data-name": "<Path>",
    d: "M244.3,128.6c1.268-1.686,1.06-4.483.139-6.655,4.553-1.894,11.885-1.911,13.988,3.58C260.13,130.023,247.306,129.727,244.3,128.6Z",
    transform: "translate(-224.005 -117.07)",
    fill: "#8e4a40"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_19",
    "data-name": "<Path>",
    d: "M254.223,122.211a13.978,13.978,0,0,1,4.466,2.52c-2.485-4.657-9.279-4.553-13.588-2.763a5.576,5.576,0,0,1,.208.573A11.9,11.9,0,0,1,254.223,122.211Z",
    transform: "translate(-224.666 -117.094)",
    fill: "#b55f54"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_20",
    "data-name": "<Path>",
    d: "M189.965,138.265a1.467,1.467,0,0,0-1.442-.591,3.26,3.26,0,0,0-2.068,1.129c-.782.782-1.164,2.05-.052,2.45,1.025.348,2.45-.626,3.11-1.321C189.913,139.5,190.313,138.821,189.965,138.265Z",
    transform: "translate(-175.596 -131.011)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_21",
    "data-name": "<Path>",
    d: "M227.989,144.178a.441.441,0,0,0-.209-.226c-.3-.156-.817.313-.608.608a.4.4,0,0,0,.434.156A.479.479,0,0,0,227.989,144.178Z",
    transform: "translate(-209.814 -136.177)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_22",
    "data-name": "<Path>",
    d: "M267.035,137.083a3.5,3.5,0,0,0-1.182.678,3.238,3.238,0,0,0-1.79,2.242c-.174,1.842,2.676.851,3.475.452a2.664,2.664,0,0,0,1.6-2.033C269.311,137.257,267.9,136.84,267.035,137.083Z",
    transform: "translate(-240.328 -130.472)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_23",
    "data-name": "<Path>",
    d: "M302.873,148.2a.622.622,0,0,0-.174-.122c-.226-.122-.608.226-.539.452a.071.071,0,0,0,.017.052.071.071,0,0,1-.017.052c-.035.452.66.035.73-.191a.017.017,0,0,1,.017-.017A.266.266,0,0,0,302.873,148.2Z",
    transform: "translate(-271.804 -139.593)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_12",
    "data-name": "<Group>",
    transform: "translate(48.585 9.411)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_24",
    "data-name": "<Path>",
    d: "M344.51,82.848c.4-.348.921-.573,1.164-1.025a4.607,4.607,0,0,0-.174-3.736,5.064,5.064,0,0,0-5.282-2.832,6.91,6.91,0,0,0-2.971-3.475c-2.381-1.355-5.543-.556-7.889.434-2.45,1.043-6.829,4.257-7.124,7.159-.417,4.4,8.549,3.614,12.233,3.249,1.129,1.877,4.813,1.442,6.777,1.216A8.6,8.6,0,0,0,344.51,82.848Z",
    transform: "translate(-322.219 -71.06)",
    fill: "#5f2d25"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_25",
    "data-name": "<Path>",
    d: "M339.044,85.495c-1.407.07-2.832.052-4.24.035-3.423-.052-9.227-.591-5.508-5.126a14.122,14.122,0,0,1,7.611-4.744c3.666-.851,5.821.886,7.35,3.423-2.311.834-5.143,3.023-5.282,5.613A3.8,3.8,0,0,0,339.044,85.495Z",
    transform: "translate(-327.075 -74.68)",
    fill: "#8e4a40"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_26",
    "data-name": "<Path>",
    d: "M336.437,77.921c2.276-.956,4.9-1.6,7.246-.9a5.827,5.827,0,0,0-5.7-1.355,14.123,14.123,0,0,0-7.611,4.744,6.329,6.329,0,0,0-.973,1.564A23.194,23.194,0,0,1,336.437,77.921Z",
    transform: "translate(-328.152 -74.682)",
    fill: "#b55f54"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_27",
    "data-name": "<Path>",
    d: "M397.74,106.7a3.47,3.47,0,0,1-1.772-.765,2.236,2.236,0,0,1-.521-1.772,3.356,3.356,0,0,1,.261-.9,6.291,6.291,0,0,1,4.222-3.649,3.258,3.258,0,0,1,2.815.052,5.153,5.153,0,0,1,2.016,1.425c1.129,1.251,1.6,3.388-.052,4.448a6.941,6.941,0,0,1-2.259.834q-.139.035-.261.07a13.777,13.777,0,0,1-2.919.434A6.451,6.451,0,0,1,397.74,106.7Z",
    transform: "translate(-382.713 -94.403)",
    fill: "#8e4a40"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_28",
    "data-name": "<Path>",
    d: "M399.662,100.909a10.388,10.388,0,0,1,3.441-1.182c-.052-.017-.087-.052-.139-.07a3.258,3.258,0,0,0-2.815-.052,6.291,6.291,0,0,0-4.222,3.649,3.182,3.182,0,0,0-.226.712A12.694,12.694,0,0,1,399.662,100.909Z",
    transform: "translate(-382.932 -94.403)",
    fill: "#b55f54"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_29",
    "data-name": "<Path>",
    d: "M353.124,110.061c-.521-.66-1.6-.452-2.276-.261-.122.052-.226.1-.348.156a.6.6,0,0,0-.4-.017,2.316,2.316,0,0,0-1.46,1.442c-.243.8.365,1.338,1.112,1.46a4.023,4.023,0,0,0,2.415-.678C352.846,111.781,353.75,110.825,353.124,110.061Z",
    transform: "translate(-344.005 -102.912)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_30",
    "data-name": "<Path>",
    d: "M377.708,121.547a.363.363,0,0,0-.417.261c0,.017-.017.052-.017.07-.017.122,0,.226.139.243h.069c.174.035.469-.209.4-.4A.223.223,0,0,0,377.708,121.547Z",
    transform: "translate(-367.702 -112.765)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_31",
    "data-name": "<Path>",
    d: "M419.037,120.035a.874.874,0,0,0-.521.069c-.782.191-1.581,1.147-.834,1.512.556.261,1.494-.452,1.651-.956C419.42,120.383,419.333,120.087,419.037,120.035Z",
    transform: "translate(-400.848 -111.514)",
    fill: "#8e4a40",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerPot);
export default __webpack_public_path__ + "static/media/flowerPot.309e10284fbb3bd2c5a1f754995fcca6.svg";
export { ForwardRef as ReactComponent };